import { useEffect } from 'react'
import PageCard from '../../common/PageCard'
import $t from '../../../i18n'
import Page from '../../common/Page'
import config from '../../../config.json'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import { getUrlParams } from '../../../utils/useParamUtil'
import { Button } from 'antd'
import { routes } from '../../../consts'

import './PaymentSuccess.css'

const PaymentSuccess = () => {
  const dispatch = useDispatch()
  const urlParams = getUrlParams()
  const deepLinkRedirectAfterSuccess = useSelector(
    state => state.payment?.deepLinkRedirectAfterSuccess
  )
  const isFullyPaidOrSubsidized = useSelector(
    state => state.payment?.isFullyPaidOrSubsidized
  )
  const { isLoggedIn } = useSelector(state => state.auth)

  const isPayingByCheckDeclared = urlParams?.check === 'true'

  function handleNavigate(path) {
    dispatch(Actions.createAction(Actions.NAVIGATED_TO, path))
  }

  useEffect(() => {
    let timer
    if (deepLinkRedirectAfterSuccess) {
      // Redirect the user after 6 seconds
      timer = setTimeout(() => {
        handleNavigate(deepLinkRedirectAfterSuccess)
      }, 6000)
    }
    // Cleanup the timer if the component is unmounted before the timer is finished
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deepLinkRedirectAfterSuccess])

  const getPageContent = () => {
    // Get the title and subtitle based on the payment method
    // If the payment is done by check, the title will be different
    // If the payment is done by check and the deep link is provided, the title will be empty
    // If the payment already completed or subsidized, the title and subtitle will be different
    if (isFullyPaidOrSubsidized) {
      return {
        title: $t(
          'pages.paymentsAndBilling.paymentCompleted.fullyPaidOrSubsidizedTitle'
        ),
        subtitle: deepLinkRedirectAfterSuccess
          ? $t(
              'pages.paymentsAndBilling.paymentCompleted.redirectFullyPaidOrSubsidized'
            )
          : $t(
              'pages.paymentsAndBilling.paymentCompleted.fullyPaidOrSubsidizedSubtitle'
            )
      }
    }

    if (isPayingByCheckDeclared) {
      return {
        title: deepLinkRedirectAfterSuccess
          ? ''
          : $t('pages.paymentsAndBilling.paymentCompleted.checkTitle'),
        subtitle: deepLinkRedirectAfterSuccess
          ? $t('pages.paymentsAndBilling.paymentCompleted.redirect')
          : $t('pages.paymentsAndBilling.paymentCompleted.checkSubtitle')
      }
    }

    return {
      title: $t('pages.paymentsAndBilling.paymentCompleted.title'),
      subtitle: deepLinkRedirectAfterSuccess
        ? $t('pages.paymentsAndBilling.paymentCompleted.redirect')
        : $t('pages.paymentsAndBilling.paymentCompleted.subtitle')
    }
  }

  const { title, subtitle } = getPageContent()

  return (
    <PageCard className='payment-success-page'>
      <Page hideAlertBanner={true} title={title}>
        <img
          className='check-image'
          src={config.gcpStorageUrl + '/img/success-check.svg'}
          alt=''
        />
        <div
          className={`payment-completed-subtitle ${
            deepLinkRedirectAfterSuccess ? 'redirect-message' : ''
          }`}
        >
          {subtitle}
          {deepLinkRedirectAfterSuccess && <span className='dots' />}
          {!isLoggedIn && !deepLinkRedirectAfterSuccess && (
            <div className='payment-actions-container'>
              <Button
                type='primary'
                onClick={() => handleNavigate(routes.SIGN_IN)}
              >
                {$t('pages.getStarted.signinForm.logIn')}
              </Button>
            </div>
          )}
        </div>
      </Page>
    </PageCard>
  )
}

export default PaymentSuccess
